import React, { useState, useEffect } from 'react';
import { Button, ColorPicker, Form, Input, Select, Upload, message } from 'antd';
import { UploadOutlined, DeleteOutlined } from '@ant-design/icons';
import { useUploadCompanyLogo } from '../hooks/useFetch';
import { EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons';
import { USER_ROLE_OPTIONS } from '../../../../data/constant';

// สีสำเร็จรูปให้เลือกเร็ว ๆ — เลือกสีเองก็ยังได้
const COLOR_PRESETS = [
  {
    label: 'แนะนำ',
    colors: ['#ffffff', '#fa8c16', '#f5222d', '#52c41a', '#1677ff', '#722ed1', '#13c2c2', '#fadb14'],
  },
];

const MAX_LOGO_MB = 1;

function FormEmployee({ formRef, onFinish, initialValues = {}  }) {
  // เก็บ URL ไว้โชว์ตัวอย่าง — ค่าจริงส่งผ่าน Form.Item ชื่อ logoUrl
  const [logoUrl, setLogoUrl] = useState(initialValues.logoUrl || null);
  const { mutateAsync: uploadLogo, isLoading: isUploading } = useUploadCompanyLogo();

  useEffect(() => { setLogoUrl(initialValues.logoUrl || null); }, [initialValues.logoUrl]);

  const setField = (url) => {
    setLogoUrl(url);
    formRef.current?.setFieldsValue({ logoUrl: url });
  };

  const handleUpload = async (file) => {
    if (file.size > MAX_LOGO_MB * 1024 * 1024) {
      message.error(`ไฟล์ใหญ่เกิน ${MAX_LOGO_MB} MB`);
      return Upload.LIST_IGNORE;
    }
    try {
      const base64 = await new Promise((res, rej) => {
        const r = new FileReader();
        r.onload = () => res(r.result);
        r.onerror = rej;
        r.readAsDataURL(file);
      });
      const resp = await uploadLogo({ companyId: initialValues.id || 'new', file: base64 });
      const url = resp?.result?.logoUrl;
      if (!url) throw new Error('ไม่ได้รับลิงก์ไฟล์กลับมา');
      setField(url);
      message.success('อัปโหลดโลโก้สำเร็จ — อย่าลืมกดบันทึก');
    } catch (e) {
      message.error(e?.response?.data?.message || e.message || 'อัปโหลดไม่สำเร็จ');
    }
    return Upload.LIST_IGNORE;
  };

  return (
    <Form name="Form" ref={formRef} layout="vertical" onFinish={onFinish} initialValues={initialValues}>
      <div className='mt-5 grid lg:gap-x-5 lg:grid-cols-1 '>

        <Form.Item className='block mb-2 text-sm font-medium text-gray-700' name="companyName" label="Company Name" rules={[{ required: true, message: 'กรุณาระบุชื่อผู้ใช้' }]}>
          <Input
            className="w-full px-3 py-2 text-gray-700 border rounded-lg focus:outline-none"
            placeholder="Company Name"
          />
        </Form.Item>

        {/* ColorPicker คืนค่าเป็น Color object ไม่ใช่ string → แปลงเป็น hex ตรงนี้
            ไม่งั้นจะได้ "[object Object]" ลง DB */}
        {/* โลโก้ใช้เป็นไอคอนบนแท็บเบราว์เซอร์ (favicon) ของบริษัทนั้น */}
        <Form.Item name="logoUrl" hidden><Input /></Form.Item>
        <Form.Item className='block mb-2 text-sm font-medium text-gray-700' label="โลโก้บริษัท (ใช้เป็นไอคอนแท็บ)">
          <div className="flex items-center gap-3 flex-wrap">
            {logoUrl && (
              <img
                src={logoUrl}
                alt="โลโก้"
                style={{ width: 48, height: 48, objectFit: 'contain',
                         border: '1px solid #d9d9d9', borderRadius: 6, background: '#fff' }}
              />
            )}
            <Upload accept=".png,.jpg,.jpeg,.webp,.ico,.svg,image/*" showUploadList={false}
                    beforeUpload={handleUpload}>
              <Button icon={<UploadOutlined />} loading={isUploading}>
                {logoUrl ? 'เปลี่ยนโลโก้' : 'อัปโหลดโลโก้'}
              </Button>
            </Upload>
            {logoUrl && (
              <Button danger icon={<DeleteOutlined />} onClick={() => setField(null)}>ลบ</Button>
            )}
          </div>
          <div className="text-xs text-gray-400 mt-1">
            แนะนำรูปสี่เหลี่ยมจัตุรัส 64×64 ขึ้นไป · png / jpg / webp / ico / svg ไม่เกิน {MAX_LOGO_MB} MB
          </div>
        </Form.Item>

        <Form.Item
          className='block mb-2 text-sm font-medium text-gray-700'
          name="themeColor"
          label="สีชื่อบริษัท (แสดงบนแถบเมนู)"
          getValueFromEvent={(color) =>
            typeof color === 'string' ? color : color?.toHexString?.() ?? null
          }
        >
          <ColorPicker
            format="hex"
            allowClear
            presets={COLOR_PRESETS}
            showText={(color) => <span>{color.toHexString()}</span>}
          />
        </Form.Item>
      </div>
    </Form>
  );
}

export default FormEmployee;

